<ion-card>
  <ion-card-header>
    <ion-card-title>Adminisztrátori jogosultságok</ion-card-title>
    <ion-card-subtitle>Ki számít adminnak — területenként, jogkörre vagy névre</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <ng-container *ngIf="!toltodik">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        Ez a kérdés eddig <b>a kódban</b> dőlt el, modulonként külön — megnézni sem lehetett,
        átállítani pedig végképp nem. Itt <b>jogkört</b> (mindenki, aki azt viseli) és
        <b>egyetlen embert</b> is felvehetsz. A módosítás azonnal érvényes, újbóli belépés
        nélkül.
      </ion-note>

      <!-- ÖNELLENŐRZÉS. Erre a képernyőre jellemzően azért jön valaki, mert valami
           zárva van előtte. Kezdjük azzal, hogy megmondjuk, miért. -->
      <div class="jog-onellenorzes" *ngIf="onellenorzes">
        <h3>Te most minek számítasz</h3>
        <div class="jog-kilet">
          <span *ngIf="onellenorzes.adid"><b>{{ onellenorzes.adid }}</b></span>
          <span *ngIf="onellenorzes.jogkorok?.length">
            · jogkör: {{ onellenorzes.jogkorok.join(', ') }}
          </span>
          <span *ngIf="!onellenorzes.dolgozo" class="jog-nincs">
            Ebben az intézményben nincs feladatellátásod — így egyik területen sem vagy admin.
          </span>
        </div>
        <div class="jog-allapot" *ngFor="let t of onellenorzes.teruletek">
          <ion-icon [name]="t.admin ? 'checkmark-circle' : 'close-circle'"
                    [color]="t.admin ? 'success' : 'medium'"></ion-icon>
          <div>
            <b>{{ t.nev }}</b>
            <div class="jog-ok">{{ okSzoveg(t) }}</div>
          </div>
        </div>
      </div>

      <!-- TERÜLETEK. A '*' mindenhol érvényes; a nevesítettek csak a saját helyükön.
           Ez azért fontos, mert az "admin" nem mindenhol ugyanazt jelentette. -->
      <div class="jog-terulet" *ngFor="let ter of teruletek">
        <div class="jog-terulet-fej">
          <h3>{{ ter.nev }}</h3>
          <span class="jog-jelolo" *ngIf="ter.terulet === '*'">mindenre érvényes</span>
        </div>
        <p class="jog-leiras">{{ ter.leiras }}</p>

        <div class="jog-lista">
          <div class="jog-tetel" *ngFor="let t of tetelekTerulethez(ter.terulet)">
            <ion-icon [name]="t.fajta === 'jogkor' ? 'people-outline' : 'person-outline'"></ion-icon>
            <div class="jog-tetel-nev">
              <b>{{ t.fajta === 'jogkor' ? jogkorNev(t.ertek) : felhasznaloNev(t.ertek) }}</b>
              <span class="jog-tetel-tipus">{{ t.fajta === 'jogkor' ? 'jogkör' : 'felhasználó' }}</span>
              <div class="jog-tetel-megj" *ngIf="t.megjegyzes">{{ t.megjegyzes }}</div>
            </div>
            <ion-button fill="clear" color="danger" size="small" (click)="torol(t)">
              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>
          </div>
          <div class="jog-ures" *ngIf="!tetelekTerulethez(ter.terulet).length">
            Ide senki nincs külön felvéve
            <span *ngIf="ter.terulet !== '*'">— itt csak az általános adminisztrátorok járnak el.</span>
          </div>
        </div>
      </div>

      <!-- FELVÉTEL -->
      <div class="jog-felvetel">
        <h3>Új jogosult felvétele</h3>
        <ion-grid>
          <ion-row>
            <ion-col size="12" sizeMd="6">
              <ion-select label="Terület" label-placement="stacked" fill="outline"
                          interface="popover" [(ngModel)]="ujTerulet">
                <ion-select-option *ngFor="let t of teruletek" [value]="t.terulet">{{ t.nev }}</ion-select-option>
              </ion-select>
            </ion-col>
            <ion-col size="12" sizeMd="6">
              <ion-select label="Mit veszel fel" label-placement="stacked" fill="outline"
                          interface="popover" [(ngModel)]="ujFajta" (ngModelChange)="ujErtek = ''">
                <ion-select-option value="jogkor">Jogkört — mindenki, aki azt viseli</ion-select-option>
                <ion-select-option value="felhasznalo">Egy embert — név szerint</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="ujFajta === 'jogkor'">
            <ion-col size="12">
              <ion-select label="Jogkör" label-placement="stacked" fill="outline"
                          interface="popover" placeholder="válassz" [(ngModel)]="ujErtek">
                <ion-select-option *ngFor="let j of jogkorok" [value]="j.jogkor">
                  {{ j.name }} ({{ j.jogkor }})
                </ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="ujFajta === 'felhasznalo'">
            <ion-col size="12" sizeMd="5">
              <ion-input label="Keresés" label-placement="stacked" fill="outline"
                         placeholder="név vagy azonosító" [(ngModel)]="szuro"></ion-input>
            </ion-col>
            <ion-col size="12" sizeMd="7">
              <ion-select label="Munkatárs" label-placement="stacked" fill="outline"
                          interface="popover" placeholder="válassz" [(ngModel)]="ujErtek">
                <ion-select-option *ngFor="let m of szurtMunkatarsak" [value]="m.adid">
                  {{ m.viselt_vez }} {{ m.viselt_ker }} ({{ m.adid }})
                </ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <ion-input label="Megjegyzés (miért kapta)" label-placement="stacked" fill="outline"
                         placeholder="pl. igazgatóhelyettes, 2026/27" [(ngModel)]="ujMegjegyzes"></ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-button color="primary" [disabled]="ment || !ujErtek" (click)="felvesz()">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          {{ ment ? 'Felvétel…' : 'Felvétel' }}
        </ion-button>
      </div>

      <ion-note color="medium" style="display:block;margin-top:16px;font-size:12px">
        A <b>„{{ teruletNev('*') }}"</b> mindenhol érvényes — a most létező és a később
        érkező területeken is. A nevesített területek csak a saját helyükön adnak jogot:
        aki például a késéseknél admin, attól még nem léphet be más nevében. Ez szándékos,
        mert az „admin" szó eddig sem ugyanazt jelentette mindenhol.
      </ion-note>
    </ng-container>
  </ion-card-content>
</ion-card>
